"use strict";
/** state: Final **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var CLASS_NAME = 'i-label';
/**
 * Labels are used to describe form elements.
 *
 * Every form element should have a label,
 * although in some cases they may only be accessible via screen readers.
 */
var Label = function (_a) {
    var children = _a.children, className = _a.className, label = _a.label, labelHidden = _a.labelHidden, optional = _a.optional, required = _a.required, restProps = __rest(_a, ["children", "className", "label", "labelHidden", "optional", "required"]);
    return (React.createElement("label", __assign({ className: classNames(CLASS_NAME, className) }, restProps),
        React.createElement("div", { className: CLASS_NAME + "__text" },
            required && (React.createElement("span", { "aria-hidden": true, className: CLASS_NAME + "__required", title: required }, "*")),
            React.createElement("span", { className: classNames({ 'sr-only': labelHidden }) }, label),
            optional && (React.createElement("span", { className: CLASS_NAME + "__optional" },
                "(",
                optional,
                ")")),
            required && React.createElement("span", { className: "sr-only" }, required)),
        children));
};
exports.Label = Label;
//# sourceMappingURL=Label.js.map